<template>
  <div :class="[baseCss, block ? 'block' : ['inline-block', 'align-middle']]">
    <canvas v-if="outputMode === 'canvas'" />
    <div v-else v-html="output" />
  </div>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'QrCode',
  mixins: [
    methods
  ],
  data () {
    return {
      output: null,
      baseCss: this.componentBaseCss('qr-code', [])
    }
  },
  props: {
    outputMode: {
      type: String,
      default: 'canvas',
      validator: value => {
        return [
          'canvas',
          'svg'
        ].includes(value)
      }
    },
    block: {
      type: Boolean,
      default: true
    },
    quietZone: {
      type: Number,
      default: 4
    },
    errorCorrectionLevel: {
      type: String,
      default: 'M',
      validator: value => {
        return [
          'L',
          'M',
          'Q',
          'H'
        ].includes(value)
      }
    },
    version: {
      type: Number,
      validator: value => {
        return value > 0 && value <= 41
      }
    },
    maskPattern: {
      type: Number,
      validator: value => {
        return value > -1 && value <= 7
      }
    },
    size: {
      type: Number
    },
    colorDark: {
      type: String,
      default: '#000000'
    },
    colorLight: {
      type: String,
      default: '#ffffff'
    },
    scale: {
      type: Number,
      default: 4
    },
    text: {
      type: String,
      required: true
    }
  },
  watch: {
    text () {
      this.makeQrCode()
    }
  },
  mounted () {
    this.makeQrCode()
  },
  methods: {
    makeQrCode () {
      const text = this.text
      const outputMode = this.outputMode
      const options = {
        scale: this.scale,
        version: this.version,
        errorCorrectionLevel: this.errorCorrectionLevel,
        width: this.size,
        margin: this.quietZone,
        maskPattern: this.maskPattern,
        color: {
          dark: this.colorDark,
          light: this.colorLight
        }
      }
      switch (outputMode) {
        case 'canvas':
          window.QRCode.toCanvas(this.$el.querySelector('canvas'), text, options, (error) => {
            if (error) {
              console.error(error)
            }
            this.ready({text})
          })
          break
        case 'svg':
          window.QRCode.toString(text, options, (error, svg) => {
            if (error) {
              console.error(error)
            }
            this.output = svg
            this.ready({text, svg})
          })
      }
    },
    ready (data) {
      this.$emit('ready', data)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/qr-code/qr-code.vue